<template>
    <div class="footer">
        <div class="main" flex="" v-if="pcConfig">
            <div class="footer-left">
                <div class="logo f0">
                    <img src="@/assets/image2/logo-big.png" />
                </div>
                <div class="name">瑞安市立邦网络技术有限公司</div>
                <div class="name-en">Ruian Libang Network Technique Co.,Ltd.</div>
                <div class="location" flex="cross:center">
                    <div class="icon f0">
                        <img src="@/assets/image2/map-1.png" />
                    </div>
                    <div class="text">{{$lang.get().address}}</div>
                </div>
                <div class="location" flex="cross:center">
                    <div class="icon f0">
                        <img src="@/assets/image2/tel.png" />
                    </div>
                    <div class="text" v-if="pcConfig">{{pcConfig.footer_tel}}<span></span></div>
                    <div class="icon f0" style="margin-left: 40px;">
                        <img src="@/assets/image2/mail.png" />
                    </div>
                    <div class="text">{{pcConfig.footer_email}}</div>
                    <div class="icon f0" style="margin-left: 40px;">
                        <img src="@/assets/image2/wechat.png" />
                    </div>
                    <div class="text">{{pcConfig.footer_wechat}}</div>
                </div>
                <div class="location" flex="cross:center">
                    <div class="icon f0">
                        <img src="@/assets/image2/cal.png" />
                    </div>
                    <div class="text">{{$lang.getLang() == 'cn' ? pcConfig.cn_footer_mobile1 : pcConfig.en_footer_mobile1}}<span></span>{{$lang.getLang() == 'cn' ? pcConfig.cn_footer_mobile2 : pcConfig.en_footer_mobile2}}</div>
                </div>
            </div>
            <div class="footer-right">
                <div class="title">{{$lang.get().qrcode}}</div>
                <div class="line"></div>
                <div class="qrcodes" flex="">
                    <div class="qrcode">
                        <div class="image">
                            <img :src="$util.img(pcConfig.footer_wcom_qrcode)" />
                        </div>
                        <div class="text" v-html="$lang.get().weCom"></div>
                    </div>
                    <div class="qrcode">
                        <div class="image">
                            <img :src="$util.img(pcConfig.footer_wechat_qrcode)" />
                        </div>
                        <div class="text">{{$lang.get().wechat}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-text">
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33038102330767" target="_blank">{{$lang.get().anbei}} 33038102330767</a>
            <span></span>
            <a href="http://beian.miit.gov.cn" target="_blank">{{$lang.get().icp}} 06055174-1</a>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            pcConfig: null
        }
    },
    mounted(){
        this.getPcConfig()
    },
    methods: {
        async getPcConfig(){
            let res = await this.$api.rApi('config/pc/info')
            if(res.status == 1){
                let pcConfig = {}
                res.data.forEach(item => {
                    if(item.name == 'cn_index_swiper' || item.name == 'en_index_swiper'){
                        item.value = item.value ? JSON.parse(item.value) : []
                    }
                    pcConfig[item.name] = item.value
                })
                this.pcConfig = pcConfig
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .footer{
        width: 100%;
        height: 494px;
        background-image: url('../assets/image2/footer-bg.jpg');
        background-position: center center;
        background-size: 100% 100%;
        .footer-left{
            margin-left: 71px;
            .logo{
                padding-top: 68px;
                img{
                    width: 238.78px;
                    height: 82.65px;
                }
            }
            .name{
                margin-top: 18px;
                font-family: Lato, Lato;
                font-weight: 400;
                font-size: 20px;
                color: #FFFFFF;
                padding-bottom: 5px;
            }
            .name-en{
                font-family: Lato, Lato;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
                margin-bottom: 40px;
            }
            .location{
                .icon{
                    img{
                        width: 21px;
                        height: 21px;
                        margin-right: 5px;
                    }
                }
                .text{
                    font-family: Lato, Lato;
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;
                    line-height: 40px;
                    span{
                        display: inline-block;
                        width: 30px;
                    }
                }
            }
        }
    }
    .footer-right{
        margin-left: 370px;
        .title{
            margin-top: 103px;
            font-family: Lato, Lato;
            font-weight: bold;
            font-size: 20px;
            color: #FFFFFF;
        }
        .line{
            margin-top: 14px;
            width: 40px;
            height: 3px;
            background: #10CE7C;
            border-radius: 0px 0px 0px 0px;
            margin-bottom: 47px;
        }
        .qrcodes{
            .qrcode{
                margin-right: 71px;
                img{
                    width: 137px;
                    height: 137px;
                }
            }
            .text{
                font-family: Lato, Lato;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                text-align: center;
                margin-top: 16px;
            }
        }
    }
    .footer-text{
        text-align: center;
        padding-top: 50px;
        a{
            font-family: Lato, Lato;
            font-weight: 400;
            font-size: 12px;
            color: #FFFFFF;
            text-decoration: none;
        }
        span{
            display: inline-block;
            width: 80px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/NewFooter.vue